export default "__VITE_ASSET__CFNPny$J__"